import axios from "axios";
import { config } from "./endPoints";
import { WebStorage, WebStorageNames, messages, Common } from "../utils";
const { BASE_HOST_URL, REST_API } = config;
const { Exception } = messages;
const {ROOT_URL}=config;
const axiosBasic = axios.create({
  baseURL: BASE_HOST_URL,
  timeout: 60000,
  headers: { Pragma: "no-cache" },
});

const issueToken = (refreshToken, deviceToken) =>
  new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    axiosBasic
      .post(
        `${ROOT_URL}${REST_API.Account.RefreshToken}`,
        {
          RefreshToken: refreshToken,
          DeviceToken: deviceToken,
        },
        { headers }
      )
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        if (err.response.status === 400 && !err.response.data.success) {
          cleanLocalStore();
        }

        reject(err);
      });
  });

  export const cleanLocalStore=()=>{
    WebStorage.removeLocalStore(WebStorageNames.AuthInfo);
    WebStorage.removeLocalStore(WebStorageNames.UserInfo);
    WebStorage.removeLocalStore(WebStorageNames.UserLoggedIn);
    Common.showErrorMessage(Exception.sessionExpired);
    window.location.href = "/";
    return;
  }

export const getAuthToken = () =>
  WebStorage.getLocalStore(WebStorageNames.AuthInfo);

export const getUserInfo = () =>
  WebStorage.getLocalStore(WebStorageNames.UserInfo);

export const configureAxiosDefaults = async () => {
  axiosBasic.defaults.baseURL = BASE_HOST_URL;
  axiosBasic.defaults.headers.post["Content-Type"] = "application/json";

  axiosBasic.interceptors.request.use(
    (configuration) => {
      const cfg = configuration;
      cfg.headers.Pragma = "no-cache";
      const url = cfg.url.toLowerCase();
      if (
        url.endsWith("login") ||
        url.endsWith("forgotpassword") ||
        url.endsWith("register") ||
        url.endsWith("contactus") ||
        url.endsWith("refreshtoken")
      ) {
        return cfg;
      }
      const res = getAuthToken();
      if (res !== null) {
        cfg.headers.Authorization = `Bearer ${res.AccessToken}`;
      }
      return Promise.resolve(cfg);
    },
    (err) => {
      Promise.reject(err);
    }
  );
};

export const axiosResponse = () => {
  axiosBasic.interceptors.response.use(null ,(err) => {
    if (err.config && err.response && err.response.status === 401) {
      const data = getAuthToken();
      const dataInfo = getUserInfo();
      if (data !== null) {
        return issueToken(data.RefreshToken, dataInfo.email).then((res) => {
          if(res.data.success){
            const { AccessToken, RefreshToken } = res.data.data;
            const authData = { AccessToken, RefreshToken };
            WebStorage.setLocalStore(WebStorageNames.AuthInfo, authData);
            WebStorage.setLocalStore(WebStorageNames.UserLoggedIn, true);
            return Promise.resolve(axiosBasic.request(err.config));
          }else{
            cleanLocalStore();
          }
         
        });
      }
      return Promise.reject(err);
    }
    if (err.message === Exception.networkError) {
      return Promise.reject(err);
    }
    return Promise.reject(err);
  });
};

export { axiosBasic };
